<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Hợp đồng</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataPermission && dataPermission.includes('CNPS_SCON_UPSERT_SELL_COMBO_CONTRACT')"
          @click="$router.push('/create-combo-contract')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus"></i> Tạo hợp đồng Combo bán hàng
        </button>
        <button
          v-if="exportPermission"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="gets">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.keySearch"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group" v-if="defaultGroupService === null">
            <Select2
              v-model="search.groupService"
              :options="Config.getSearch(dataGroupServiceSelect)"
              @change="queryService($event)"
              placeholder="Nhóm dịch vụ"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="sales-manager"
              v-model="search.serviceTypes"
              :options="dataConfigService"
              :settings="{ placeholder: 'Dịch vụ' }"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="sales-manager"
              v-model="search.regionIds"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              :settings="{ placeholder: 'Vùng kinh doanh' }"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.cityCodes"
              :options="dataProvince"
              :settings="{ placeholder: 'Tỉnh/Thành phố' }"
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.code"
              type="text"
              class="f12"
              placeholder="Số hợp đồng"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.formContract"
              :options="formContract"
              placeholder="Hình thức"
            />
          </div>
          <div class="form-group" v-if="['PAYMENT', null].includes(defaultGroupService)">
            <Select2
              v-model="search.paymentType"
              :options="paymentTypeData"
              placeholder="Hình thức mua TB"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.ownershipType"
              :options="ownershipTypeData"
              placeholder="Hình thức sở hữu TB"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.isDefaultFee" :options="isDefaulValue" placeholder="Phí" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeCustomer"
              :options="customerType"
              placeholder="Loại hợp đồng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isPolicyContract"
              :options="listPolicyContract"
              placeholder="Loại HDDT"
            />
          </div>
          <div class="form-group" v-if="['PAYMENT', null].includes(defaultGroupService)">
            <Select2 v-model="search.superiorId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Nhân viên" />
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Trạng thái', closeOnSelect: false }"
              v-model="search.state"
              :options="listStatusContract"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.agentId"
              :options="listCollaborators"
              placeholder="Cộng tác viên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.stateCollaborator"
              :options="listStateCollaborator"
              placeholder="Trạng thái GS"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reserveStatus"
              :options="listreserved"
              placeholder="Trạng thái bảo lưu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.megabizStt"
              :options="statusMegabiz"
              placeholder="Trạng thái Megabiz"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusReceipt"
              :options="listStatusReceipt"
              placeholder="Trạng thái phiếu thu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusHandover"
              :options="Config.getSearch(Config.statusHandoverList)"
              placeholder="Trạng thái bàn giao"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.referSource" :options="sourceCreate" placeholder="Nguồn tạo" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.agentGroup" :options="dataAgentGroup" placeholder="Nhóm CTV" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approverId"
              :options="listUser"
              placeholder="Người duyệt/từ chối"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.confirmInvoice"
              :options="Config.getSearch(Config.confirmInvoice)"
              placeholder="Xác thực TTNHĐ"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.unprocessInvoice"
              :options="listUnprocessInvoice"
              placeholder="Cần check thông tin hóa đơn?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcLvl"
              :options="Config.getSearch(Config.mcKeyLvl)"
              placeholder="Cấp bậc MC"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.ownPOS"
              :options="Config.getSearch(Config.ownPOS)"
              placeholder="Đã có POS?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.hasBusinessRegistrationNumber"
              :options="listChoose"
              placeholder="Đã đánh dấu có/không ĐKKD?"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcNewTPV"
              :options="listChoose"
              placeholder="Đã đánh dấu MC mới/cũ (TPV)"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.keySearch" :options="dataCat" placeholder="Loại thiết bị " />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.isTransferNganluong"
              :options="listTransferNganluong"
              placeholder="Ký HĐ Ngân Lượng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.nganluongTransferStatus"
              :options="listTransferNganluongStatus"
              placeholder="Trạng thái ký Ngân Lượng"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="activeDate"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian kích hoạt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="nganluongDateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Ngày tạo HĐ Ngân Lượng
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group form-group-action" style="height: 41px">
            <button
              type="button"
              @click="gets()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            <div class="mb-1 d-flex align-items-center flex-wrap" style="gap: 16px">
              <span>
                Tổng hợp đồng:
                <strong class="text-primary" style="font-size: 1.1em">
                  {{
                    objectCount.totalContract
                      ? objectCount.totalContract.toLocaleString('vi-VN')
                      : '0'
                  }}
                </strong>
              </span>
              <span class="text-muted">|</span>
              <span>
                Chưa ký:
                <strong class="text-primary" style="font-size: 1.1em">
                  {{
                    objectCount.totalNotSign
                      ? objectCount.totalNotSign.toLocaleString('vi-VN')
                      : '0'
                  }}
                </strong>
              </span>
              <span class="text-muted">|</span>
              <span>
                Đã ký:
                <strong class="text-primary" style="font-size: 1.1em">
                  {{
                    objectCount.totalSigned ? objectCount.totalSigned.toLocaleString('vi-VN') : '0'
                  }}
                </strong>
              </span>
            </div>
            <b-overlay :show="loading" opacity="0.6" rounded="sm">
              <b-table
                sticky-header
                hover
                responsive
                :items="listContract"
                :fields="filterTable"
                :fixed="true"
                :bordered="true"
              >
                <!-- <template #table-busy>
                <div class="my-3">
                <div class="d-flex align-items-center justify-content-center">
                 <div class="text-center">
                   <b-spinner class="align-middle"></b-spinner>
                  <p class="ml-2 mt-2">Đang tải dữ liệu...</p>
                 </div>
                </div>
                </div>
              </template> -->
                <template #cell(index)="data">
                  {{ getIndex(data.index) }}
                </template>
                <template #cell(groupService)="data">
                  {{ data.item.groupService | fomatTextService(dataGroupService) }}
                </template>
                <template #cell(service)="data">
                  {{ data.item.service | serviceTypes }}
                </template>
                <template #cell(merchant)="data">
                  <p>
                    <span>{{
                      data.item.merchantData ? data.item.merchantData.merchantName : ''
                    }}</span>
                  </p>
                  <p
                    v-if="
                      !(
                        data.item.merchantData &&
                        data.item.merchantData.accIdType &&
                        data.item.merchantData.accIdType === 'MOBILE'
                      )
                    "
                  >
                    <a href="#">{{ data.item.merchantData ? data.item.merchantData.email : '' }}</a>
                  </p>
                  <p>
                    <a href="#">{{
                      data.item.merchantData ? data.item.merchantData.mobile : '' | encryptPhone
                    }}</a>
                  </p>
                  <p>
                    <span
                      >{{ data.item.merchantData ? data.item.merchantData.address : '' }},
                      {{ data.item.merchantData ? data.item.merchantData.district : '' }},
                      {{ data.item.merchantData ? data.item.merchantData.city : '' }}</span
                    >
                  </p>
                  <p>
                    <Status :value="data.item.mcLvl" :config="Config.mcKeyLvl" />
                  </p>
                </template>
                <template #cell(time)="data">
                  <p>
                    HĐ:
                    <span>{{
                      data.item.typeCustomer ? data.item.typeCustomer : '' | fomatCustomtype
                    }}</span>
                  </p>
                  <p>
                    Số: <b>{{ data.item.code }}</b>
                  </p>

                  <p
                    v-if="
                      data.item.dateCreate &&
                      contractStateOther.includes(data.item.status) &&
                      data.item.formContract === 'E_CONTRACT'
                    "
                  >
                    Ngày tạo: <span>{{ data.item.dateCreate | formatDate }}</span>
                  </p>
                  <p v-if="data.item.approvedOrRejectedDate">
                    Ngày duyệt/từ chối:
                    <span>{{ data.item.approvedOrRejectedDate | formatDate }}</span>
                  </p>
                  <p
                    v-else-if="
                      data.item.dateSign &&
                      ((contractStateSign.includes(data.item.status) &&
                        data.item.formContract === 'E_CONTRACT') ||
                        data.item.formContract === 'PAPER_CONTRACT') &&
                      data.item.status !== 'CANCELED'
                    "
                  >
                    Ngày ký: <span>{{ data.item.dateSign | formatDate }}</span>
                  </p>
                  <p v-else-if="data.item.dateCancel && data.item.status === 'CANCELED'">
                    Ngày huỷ: <span>{{ data.item.dateCancel | formatDate }}</span>
                  </p>
                  <p v-if="data.item.activeDate">
                    Ngày kích hoạt: <span>{{ data.item.activeDate | formatDate }}</span>
                  </p>
                  <p
                    :class="
                      isTransferNganluongSuccess(
                        data.item.isTransferNganluong,
                        data.item.isNganluongContract
                      )
                        ? 'text-success'
                        : 'text-danger'
                    "
                    class="mb-0"
                  >
                    {{
                      getNameNlLabel(data.item.isTransferNganluong, data.item.isNganluongContract)
                    }}
                  </p>
                  <p v-if="data.item.nganluongDateSign">
                    Ngày tạo HĐ Ngân Lượng:
                    <mark
                      :class="
                        isTransferNganluongSuccess(
                          data.item.isTransferNganluong,
                          data.item.isNganluongContract
                        )
                          ? 'bg-success-light'
                          : 'bg-warning'
                      "
                      style="border-radius: 10px; padding: 2px 10px"
                    >
                      {{ data.item.nganluongDateSign | formatDate }}
                    </mark>
                  </p>
                </template>
                <template #cell(appendix)="data">
                  <div v-if="data.item.codeAppendixList">
                    <p v-for="(appendixItem, index) in data.item.codeAppendixList" :key="index">
                      <b>{{ appendixItem }}</b>
                    </p>
                  </div>
                </template>
                <template #cell(devices)="data">
                  <div v-if="data.item.numDevices && data.item.numDevices !== 0">
                    <p>
                      SL: <span>{{ data.item.numDevices }}</span>
                    </p>
                    <p>
                      TT:
                      <span>{{
                        data.item.priceDevices ? data.item.priceDevices : 0 | fomatCurrency
                      }}</span>
                    </p>
                  </div>
                  <p v-if="data.item?.deposit">
                    Tiền cọc:
                    <span>{{ data.item?.deposit ? data.item?.deposit : 0 | fomatCurrency }}</span>
                  </p>
                </template>
                <template #cell(packageData)="data">
                  <p
                    v-if="
                      data.item.packageData &&
                      data.item.packageData.timePackage &&
                      data.item.packageData.timePackage !== '' &&
                      data.item.packageData.timePackage !== '0'
                    "
                  >
                    TG:
                    <span>{{
                      data.item.packageData.timePackage ? data.item.packageData.timePackage : ''
                    }}</span>
                    <br />
                    TT:
                    <span>{{
                      data.item.packageData.price ? data.item.packageData.price : 0 | fomatCurrency
                    }}</span>
                  </p>
                </template>
                <template #cell(sale)="data">
                  <p>
                    <b>{{ data.item.saleInfo ? data.item.saleInfo.name : '' }}</b>
                  </p>
                  <p>
                    <a href="#">{{ data.item.saleInfo ? data.item.saleInfo.userName : '' }}</a>
                  </p>
                  <p>{{ data.item.saleInfo ? data.item.saleInfo.regionName : '' }}</p>
                </template>
                <template #cell(referSource)="data">
                  {{ data.item.merchantData.referSource | transformData(listCTVSource) }}
                </template>
                <template #cell(confirmInvoice)="data">
                  {{ data.item.confirmInvoice | transformData(Config.confirmInvoice) }}
                </template>
                <template #cell(approvedOrRejectedExecutor)="data">
                  {{ getNameApprovedOrRejectedExecutor(data.item.approvedOrRejectedExecutor) }}
                </template>
                <template #cell(status)="data">
                  <span class="badge" :class="[data.item.status ? data.item.status : '']">
                    {{ data.item.status | mapTextStatus(listStatusContract) }}</span
                  >
                  <br />
                  {{ data.item.stateCollaborator | mapTextStatus(listStateCollaborator) }}
                </template>
                <template #cell(megabizStt)="data">
                  <span class="badge" :class="[data.item?.megabizStt ? data.item?.megabizStt : '']">
                    {{ data.item?.megabizStt | mapTextStatus(statusMegabiz) }}</span
                  >
                  <br />
                  {{ data.item.stateCollaborator | mapTextStatus(listStateCollaborator) }}
                </template>

                <template #cell(statusReceipt)="data">
                  <span
                    class="badge"
                    :class="[status ? status : '']"
                    v-for="(status, indexx) in data.item.statusReceipt"
                    :key="indexx"
                  >
                    {{ status | mapTextStatus(listStatusReceipt) }}
                  </span>
                </template>
                <template #cell(statusHandover)="data">
                  <span
                    class="badge"
                    :class="[data.item.statusHandover ? data.item.statusHandover : '']"
                  >
                    {{ data.item.statusHandover | mapTextStatus(Config.statusHandoverList) }}
                  </span>
                </template>
                <template #cell(nganluongTransferStatus)="data">
                  <span
                    class="badge"
                    :class="[
                      data.item?.nganluongTransferStatus ? data.item?.nganluongTransferStatus : '',
                    ]"
                  >
                    {{ data.item?.nganluongTransferStatus | mapNganluongTransferStatus }}
                  </span>
                </template>
                <template #cell(mposState)="data">
                  <p>Trạng thái: {{ data.item.mposState | transformData(Config.mposState) }}</p>
                  <p>Ghi chú: {{ data.item.mposNote }}</p>
                </template>
                <template #cell(reason)="data">
                  <span
                    v-if="data.item.status === 'REJECTED_SA' || data.item.status === 'REJECTED_MA'"
                  >
                    <p
                      class="form-control-plaintext f12"
                      v-if="
                        data.item.reasonRejected &&
                        data.item.reasonRejected[data.item.reasonRejected.length - 1]
                      "
                    >
                      {{
                        data.item.reasonRejected
                          ? data.item.reasonRejected[data.item.reasonRejected.length - 1]
                          : ''
                      }}
                    </p>
                    <p class="form-control-plaintext f12" v-else>
                      {{
                        data.item.reasonRejectedBYMPOS
                          ? data.item.reasonRejectedBYMPOS[
                              data.item.reasonRejectedBYMPOS.length - 1
                            ]
                          : ''
                      }}
                    </p>
                  </span>
                  <span v-if="data.item.status === 'ADDITIONAL'">
                    <p v-if="data.item.reasonAddImage && data.item.reasonAddImage[0]">
                      {{ data.item.reasonAddImage[0] }}
                    </p>
                    <p v-else-if="data.item.reasonAddInfo && data.item.reasonAddInfo[0]">
                      {{ data.item.reasonAddInfo[0] }}
                    </p>
                    <p v-else-if="data.item.reasonRejected && data.item.reasonRejected[0]">
                      {{ data.item.reasonRejected[0] }}
                    </p>
                  </span>
                </template>
                <template #cell(action)="data">
                  <b-dropdown
                    class="text-center"
                    variant="outline-light"
                    v-if="dataPermission && dataPermission.includes('CNPS_SCON_INFO_BY_CODE')"
                  >
                    <b-dropdown-item
                      type="button"
                      class="dropdown-item"
                      @click="openModalDetail(data.item)"
                    >
                      <i class="bx bx-show-alt"></i> Chi tiết
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="data.item.groupService === 'SELL' && data.item.status === 'APPROVED'"
                      type="button"
                      class="dropdown-item"
                      @click="activeModal(data.item.id)"
                    >
                      <span class="mr-2">√</span> Đã kích hoạt
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="totalRows"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <b-modal id="active-mc">
      <template #modal-header="{ close }">
        <h5>Kích hoạt</h5>
        <b-button size="sm" variant="light" @click="close(), (textNote = '')">x</b-button>
      </template>

      <template #default="{}">
        <h6 class="text-center">Nhập ghi chú</h6>
        <input v-model="textNote" />
      </template>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="activeMC">OK</b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import Config from '../../thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { ContractService } from '../../services/contract.service'
  import { AgentService } from '@/services/agent.service'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'groupService', label: 'Nhóm dịch vụ', thStyle: 'min-width: 80px' },
    { key: 'service', label: 'Dịch vụ' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'time', label: 'Hợp đồng/Ngày ký', thStyle: 'min-width: 280px' },
    { key: 'appendix', label: 'Phụ lục' },
    { key: 'devices', label: 'Thiết bị', thStyle: 'min-width: 120px' },
    { key: 'packageData', label: 'Giá gói', thStyle: 'min-width: 120px' },
    { key: 'sale', label: 'Sale' },
    { key: 'confirmInvoice', label: 'Xác thực TTNHĐ' },
    { key: 'approvedOrRejectedExecutor', label: 'Người duyệt/từ chối' },
    { key: 'referSource', label: 'Nguồn MC' },
    { key: 'mposState', label: 'Trạng thái MPOS' },
    { key: 'status', label: 'Trạng thái' },
    {
      key: 'nganluongTransferStatus',
      label: 'TT chuyển đổi Ngân Lượng',
      class: 'text-center',
      thStyle: 'min-width: 140px',
    },
    { key: 'megabizStt', label: 'Trạng thái Megabiz' },
    { key: 'statusReceipt', label: 'Trạng thái phiếu thu', thStyle: 'min-width: 80px' },
    { key: 'statusHandover', label: 'Trạng thái XNBG', thStyle: 'min-width: 80px' },

    { key: 'reason', label: 'Lý do', fixIndex: 999, class: 'text-center' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        defaultGroupService: this.$route.query.groupService ?? null,
        contractActiveId: '',
        textNote: '',
        dateRange: {
          startDate: null,
          endDate: null,
        },
        nganluongDateRange: {
          startDate: null,
          endDate: null,
        },
        activeDate: {
          startDate: null,
          endDate: null,
        },
        listStateCollaborator: [
          { id: 'APPROVED', text: 'GS đã duyệt' },
          { id: 'WAITING', text: 'Chờ GS duyệt' },
          { id: 'REJECTED', text: 'GS từ chối' },
        ],
        search: {
          limit: 15,
          page: 1,
          hasBusinessRegistrationNumber: '0',
          mcNewTPV: '0',
          isTransferNganluong: '0',
          transferNganluongStatus: '0',
        },
        dataGroupServiceSelect: [],
        dataConfigRegion: [],
        dataProvince: [],
        dataGroupService: [],
        dataConfigService: [],
        formContract: Config.formContract,
        paymentTypeData: Config.paymentType,
        ownershipTypeData: Config.ownershipTypeData,
        isDefaulValue: Config.isDefaulValue,
        customerType: Config.customerType,
        listUser: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listStatusContract: Config.listStatusContract,
        listContract: [],
        objectCount: {},
        totalRows: 0,
        loading: false,
        showLoading: false,
        contractStateSign: [
          'SIGNED_MISS_IMAGE',
          'SIGNED_WAITING_APPROVED',
          'APPROVED',
          'LIQUIDATE',
          'REJECTED_SA',
          'ADDITIONAL',
        ],
        contractStateOther: [
          'NEW',
          'WAITING_APPROVED_FEE',
          'APPROVED_FEE',
          'SENT',
          'WAITING_SIGN',
          'SIGNING',
          'REJECTED_MC',
          'REJECTED_MA',
        ],
        listCTVSource: [
          { id: '0', text: 'Tất cả' },
          { id: 'DIRECT_SALES', text: 'DirectSales' },
          { id: 'AGENCY', text: 'Cộng tác viên' },
          { id: 'MARKETING', text: 'Marketing' },
        ],
        listCollaborators: [],
        reasonRejectedAction: '',
        listStateContract: [],
        listreserved: [{ id: 0, text: 'Tất cả' }, ...(Config.reserveStatusOptions || [])],
        listStatusReceipt: [
          { id: 0, text: 'Tất cả' },
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'PENDING_APPROVAL', text: 'Chờ duyệt' },
          { id: 'DONE', text: 'Đã thu tiền' },
          { id: 'CANCEL', text: 'Bị huỷ' },
          { id: 'WAIT_SETTLEMENT', text: 'Chờ kết toán' },
        ],
        listPolicyContract: [
          { id: 0, text: 'Tất cả' },
          { id: true, text: 'HDDT thường' },
          { id: false, text: 'HDDT đề xuất chính sách' },
        ],
        listUnprocessInvoice: [
          { id: true, text: 'Có' },
          { id: false, text: 'Không' },
        ],
        listChoose: [
          { id: '0', text: 'Tất cả' },
          { id: 'true', text: 'Đã đánh dấu' },
          { id: 'false', text: 'Chưa đánh dấu' },
        ],
        listTransferNganluong: [
          { id: '0', text: 'Tất cả' },
          { id: 'true', text: 'Đã chuyển đổi' },
          { id: 'false', text: 'Chưa chuyển đổi' },
        ],
        listTransferNganluongStatus: [
          { id: '0', text: 'Tất cả' },
          { id: 'PENDING', text: 'Chờ duyệt' },
          { id: 'APPROVED', text: 'Hoàn thành' },
          { id: 'REJECTED', text: 'Từ chối' },
          { id: 'MC_SIGNED_WAITING_NL_SIGN', text: 'MC đã ký, chờ NL ký' },
        ],
        statusMegabiz: [],
        dataCat: [
          { id: 'TingBox01', text: 'TingBox01' },
          { id: 'TingBox02', text: 'TingBox02' },
        ],
        dataAgentGroup: [],
        sourceCreate: Config.sourceCreate,
        isTextInputActive: false,
        hasDefaultFilter: true,
        isFirstLoad: true,
      }
    },

    watch: {
      'search.page': function () {
        this.gets()
      },
      'search.limit': function () {
        this.gets()
      },
      '$route.query.groupService': {
        handler: function (search) {
          this.defaultGroupService = search ?? null
          if (this.isFirstLoad) {
            // Lần đầu tiên load
            this.isFirstLoad = false
          } else {
            // Các lần sau khi thay đổi groupService, reset params và gán lại thời gian mặc định 3 ngày
            const { from, to } = getLastNDays(3, 'date')
            this.dateRange = {
              startDate: from,
              endDate: to,
            }
            this.search = {
              page: 1,
              limit: 15,
            }
            this.activeDate = {
              startDate: null,
              endDate: null,
            }
            this.nganluongDateRange = {
              startDate: null,
              endDate: null,
            }
            this.dataProvince = []
            this.hasDefaultFilter = true
            this.gets()
          }
          this.groupService()
        },
        deep: true,
        immediate: true,
      },
    },

    created() {
      const { from, to } = getLastNDays(3, 'date')
      this.dateRange = {
        startDate: from,
        endDate: to,
      }
      // Gọi gets() trước để lấy dữ liệu chính ngay khi khởi tạo
      this.gets()
      // Các hàm lấy dữ liệu phụ gọi song song, không phụ thuộc nhau
      Promise.all([
        this.getRegions(),
        this.groupService(),
        this.getListStaffBySuperior(),
        this.getListCTV(),
        this.fetchDataDevice(),
        this.getListAgentGroup(),
        this.fetchSttMegabiz(),
      ])
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      exportPermission() {
        if (this.defaultGroupService === 'PAYMENT')
          return this.dataPermission.includes('CNPS_SCON_XLS_PAYMENT')
        else if (this.defaultGroupService === 'SELL')
          return this.dataPermission.includes('CNPS_SCON_XLS_SELL')
        else return true
      },
      getNameNlLabel() {
        // isTransferNganluong_isNganluongContract
        const mapValues = {
          [`${true}_${true}`]: 'Đã ký Ngân Lượng',
          [`${true}_${false}`]: '',
          [`${false}_${true}`]: '',
          [`${false}_${false}`]: 'Chưa ký Ngân Lượng',
        }
        return (isTransferNganluong = false, isNganluongContract = false) => {
          return mapValues[`${isTransferNganluong}_${isNganluongContract}`] || ''
        }
      },
      isTransferNganluongSuccess() {
        return (isTransferNganluong = false, isNganluongContract = false) => {
          return isTransferNganluong && isNganluongContract
        }
      },
    },
    methods: {
      async getListAgentGroup() {
        try {
          const listAgent = await AgentService.getListAgentGroup()
          this.dataAgentGroup = listAgent.data.map(e => {
            return { id: e.code, text: e.name }
          })
          this.dataAgentGroup.unshift({ id: 0, text: 'Tất cả' })
        } catch (error) {
          console.log(error)
        }
      },
      activeModal(data) {
        this.$bvModal.show('active-mc')
        this.contractActiveId = data
      },
      async fetchSttMegabiz() {
        try {
          const data = await ContractService.getListStatusMegabiz({})
          if (data.success) {
            const list = data.data.contractStt || []
            this.statusMegabiz = list.map(e => ({
              id: e.code,
              text: e.name,
              ...e,
            }))
          }
        } catch (error) {
          console.log(error)
        }
      },
      async activeMC() {
        try {
          this.$bvModal.hide('active-mc')
          const data = await SalesManagerService.activeMerchant({
            contractId: this.contractActiveId,
            note: this.textNote,
          })
          if (data.success) {
            this.showSuccesMx('Đã kích hoạt')
            await this.gets()
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.textNote = ''
        }
      },
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            const dataUser = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
              dataUser.push(body)
            })
            this.listUser = dataUser
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },

      openModalDetail(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/sales-manager/detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/contract-detail-ecommerce/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        }
      },

      clearSearch() {
        this.search = {
          page: 1,
          limit: 15,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.activeDate = {
          startDate: null,
          endDate: null,
        }
        this.nganluongDateRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.hasDefaultFilter = false
        this.gets()
      },

      removeDefaultFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.gets()
      },

      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = [
            {
              id: 0,
              text: 'Tất cả',
            },
          ]
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },

      async groupService() {
        try {
          const respon = await SalesManagerService.getGroupService({})
          if (respon.code === 1000) {
            this.dataGroupService = respon.data.groupService
            if (this.defaultGroupService) {
              this.queryService(this.defaultGroupService)
            } else {
              this.dataGroupServiceSelect = this.dataGroupService.map(e => ({
                id: e.service,
                text: e.name,
              }))
            }
            return
          }
          this.dataGroupService = []
        } catch (error) {
          console.log(error)
        }
      },

      async queryProvince(e) {
        try {
          this.search.cityCodes = null
          const data = await StaffService.getProvinceRegion({ regionId: e })
          if (data.data.length > 0) {
            const dataProvince = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.code,
                text: e.name,
              }
              dataProvince.push(body)
            })
            this.dataProvince = dataProvince
            return
          }
          this.dataProvince = []
        } catch (error) {}
      },

      async queryService(service) {
        try {
          if (!service) return
          this.dataConfigService = []
          const data = this.dataGroupService.find(e => e.service === service)
          if (data.detail.length > 0) {
            data.detail.map(e => {
              const body = {
                id: e.code,
                text: this.serviceTypes(e.name),
              }
              this.dataConfigService.push(body)
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      async formatData() {
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()

        this.search.activeFrom = moment(this.activeDate.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.activeTo = moment(this.activeDate.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()

        this.search.nganluongDateSignFrom = moment(this.nganluongDateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.nganluongDateSignTo = moment(this.nganluongDateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
        if (this.search.hasBusinessRegistrationNumber === 'true') {
          this.search.hasBusinessRegistrationNumber = true
        } else if (this.search.hasBusinessRegistrationNumber === 'false') {
          this.search.hasBusinessRegistrationNumber = false
        }

        if (this.search.mcNewTPV === 'true') {
          this.search.mcNewTPV = true
        } else if (this.search.mcNewTPV === 'false') {
          this.search.mcNewTPV = false
        }

        if (this.search.isTransferNganluong === 'true') {
          this.search.isTransferNganluong = true
        } else if (this.search.isTransferNganluong === 'false') {
          this.search.isTransferNganluong = false
        }

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }

        if (this.search.serviceTypes && this.search.serviceTypes.length === 0)
          delete this.search.serviceTypes
        if (this.search.regionIds && this.search.regionIds.length === 0)
          delete this.search.regionIds
        if (this.search.cityCodes && this.search.cityCodes.length === 0)
          delete this.search.cityCodes

        if (this.search.cityCodes && this.search.cityCodes !== null) {
          this.search.cityCodes.map((e, key) => {
            if (e === '0') {
              this.search.cityCodes.splice(key, 1)
              if (this.search.cityCodes.length === 0) {
                delete this.search.cityCodes
              }
            }
          })
        }

        if (this.search.regionIds && this.search.regionIds !== null) {
          this.search.regionIds.map((e, key) => {
            if (e === '0') {
              this.search.regionIds.splice(key, 1)
              if (this.search.regionIds.length === 0) {
                delete this.search.regionIds
              }
            }
          })
        }

        if (this.search.code && this.search.code.includes(' ')) {
          const index = this.search.code.indexOf(' ')
          const length = this.search.code.length
          const code = this.search.code.slice(0, index) + this.search.code.slice(index + 1, length)
          this.search.code = code
        }
        if (this.search.isPolicyContract)
          this.search.isPolicyContract = Boolean(this.search.isPolicyContract)
      },

      // xuất Excel
      async exportExcel() {
        try {
          if (isNaN(this.search.dateTo)) {
            this.showFailMx('Phải lọc thời gian')
          } else {
            if (this.search.dateTo - this.search.dateFrom > 5356799999) {
              this.showFailMx('Vui lòng lọc dưới 2 tháng')
            } else {
              await this.formatData()
              const search = cloneDeep(this.search)
              search.page = 1
              search.limit = 1
              this.showLoading = true
              if (this.defaultGroupService === 'PAYMENT')
                await ContractService.exportExcelPayment(search)
              else if (this.defaultGroupService === 'SELL')
                await ContractService.exportExcelSell(search)
              else await ContractService.exportExcel(search)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async gets() {
        try {
          this.loading = true
          this.formatData()
          let data = {}
          if (this.defaultGroupService === 'PAYMENT')
            data = await ContractService.getListContractPayment(this.search)
          else if (this.defaultGroupService === 'SELL')
            data = await ContractService.getListContractSell(this.search)
          else data = await ContractService.getListContract(this.search)
          if (data.code === 1000) {
            this.objectCount = {
              totalContract: data.totalPage.total,
              totalNotSign: data.data.totalNotSign,
              totalSigned: data.data.totalSigned,
            }
            this.totalRows = data.totalPage.total
            this.listContract = data.data.contractList || []
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async getListCTV() {
        try {
          const dataItem = await AgentService.listAgentByUser({
            userId: this.dataUser.userId,
          })
          if (dataItem.success) {
            this.listCollaborators = [{ id: 0, text: 'Tất cả' }]
            dataItem.data.map(e => {
              this.listCollaborators.push({ id: e.agentId, text: e.name })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      getNameApprovedOrRejectedExecutor(data) {
        return data?.name ?? ''
      },
      async fetchDataDevice() {
        try {
          const data = await DeviceService.listCatDevice({})
          if (data.success) {
            const list = data.data.categoryList
            this.dataCat = list.map(e => ({
              id: e.abbreviation,
              text: e.abbreviation,
            }))
          }
        } catch (error) {
          console.log(error)
        }
      },
    },

    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
      mapNganluongTransferStatus(status) {
        if (!status) return ''
        const statusMap = {
          PENDING: 'Chờ duyệt',
          APPROVED: 'Đã duyệt',
          REJECTED: 'Từ chối',
          MC_SIGNED_WAITING_NL_SIGN: 'MC đã ký, chờ NL ký',
        }
        return statusMap[status] || status
      },
    },
  }
</script>

<style>
  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }

    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }

    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }

  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }

  .PENDING,
  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    color: #fff;
    background-color: #ffc107;
  }

  .APPROVED {
    color: #fff;
    background-color: #28a745;
  }

  .REJECTED {
    color: #fff;
    background-color: #dc3545;
  }

  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }

  .b-table-sticky-header {
    min-height: 50vh !important;
  }

  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
